import { createAction, props } from '@ngrx/store';
import { ResponseClientExternalChallenge, RequestClientExternalChallenge } from '../../shared/interfaces';
import { ClientExternalChallengeTypes } from '../../shared/enums';


export const getClientExternalChallenge = createAction(
    ClientExternalChallengeTypes.CLIENT_EXTERNAL_CHALLENGE,
    props<{ request: RequestClientExternalChallenge}>()
);

export const getClientExternalChallengeSucess = createAction(
    ClientExternalChallengeTypes.CLIENT_EXTERNAL_CHALLENGE_SUCCESS,
    props<{ response: ResponseClientExternalChallenge }>()
);

export const getClientExternalChallengeError = createAction(
    ClientExternalChallengeTypes.CLIENT_EXTERNAL_CHALLENGE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    ClientExternalChallengeTypes.CLEAN_STATE
);
